import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthContext } from '../../context/auth/auth'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import instance from '../api'
import { CURRENT_SUBSCRIPTION_QUERY_KEY } from './useCurrentSubscription'

const cancelChangePlan = async (subscriptionId: number, token: string) => {
  return instance.get(
    `/payment/subscriptions/${subscriptionId}/cancel-pending-change/`,
    { headers: { Authorization: `Bearer ${token}` } },
  )
}

const useCancelChangePlan = () => {
  const { token } = useAuthContext()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: ({ subscriptionId }: { subscriptionId: number }) =>
      cancelChangePlan(subscriptionId, token!),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: CURRENT_SUBSCRIPTION_QUERY_KEY,
      })
      toast.success(t('planChangeCancelledSuccessfully'))
    },
    onError: (_) => {
      toast.error(t('failedToCancelChangePlan'))
    },
  })
}

export default useCancelChangePlan
